module.exports = __webpack_public_path__ + "img/img_029@2x.e1f21279.png";